module.exports = __webpack_public_path__ + "static/media/start-inactive.90a28fdd.svg";